import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import {GridApi, GridOptions} from "ag-grid-enterprise";
import {useRef, useState} from "react";
import {IReportDateCarGroup} from "../../../../api/types/report";
import {AgGridReact} from "ag-grid-react";
import {CellClassParams, ColDef, ICellRendererParams} from "ag-grid-community";
import {useAgGridLocale} from "../../../../../../config/globalConfig";
import {DEFAULT_PLAN_COL_DEF} from "../../../../constants";
import dayjs from "dayjs";

type Props = {
    result: any
}
const DateCarGroupReport = ({result}: Props) => {
    // REPORT 7
    const [valuesDateCarGroup] = useState<IReportDateCarGroup>(result);

    // Use Ref
    const gridRefDateCarGroup = useRef<AgGridReact>(null);

    const buildColDefDateCarGroup = (): ColDef[] => {
        return [
            {
                headerName: "Data inserimento",
                headerTooltip: "Data inserimento",
                pinned: "left",
                width: 200,
                cellRenderer: (params: ICellRendererParams) => {
                    return valuesDateCarGroup.rows.length === (params.rowIndex + 1) ? "TOTALI" : dayjs(params.data.name).format("L");
                },
                cellStyle: (params: CellClassParams) => ({
                    fontWeight: valuesDateCarGroup.rows.length === (params.rowIndex + 1) ? "bold" : "normal"
                })
            },
            // TODO AGGIUNGERE GRASSETTO SU ULTIMA RIGA DEI TOTALI
            ...valuesDateCarGroup.columns.map((carGroup, index) => ({
                headerName: carGroup,
                cellRenderer: (params: ICellRendererParams) => params.data.values[index],
                minWidth: 150,
                flex: 1,
            })),
            {
                headerName: "TOT",
                pinned: "right",
                width: 200,
                cellRenderer: (params: ICellRendererParams) => params.data.tot,
                cellStyle: {
                    fontWeight: "bold"
                }
            }
        ];
    };

    const [gridApiDateCarGroup, setGridApiDateCarGroup] = useState<GridApi | null>(null);

    const onGridReadyDateCarGroup = (params: any) => {
        setGridApiDateCarGroup(params.api);
    };

    // Use AgGrid Locale
    const agGridLocale = useAgGridLocale();

    const defaultColDef = {...DEFAULT_PLAN_COL_DEF};

    const gridOptionsDateCarGroup: GridOptions = {
        rowData: valuesDateCarGroup.rows,
        columnDefs: buildColDefDateCarGroup(),
        defaultColDef: defaultColDef,
        rowSelection: "multiple",
        localeText: agGridLocale,
        suppressRowClickSelection: true,
        enableRangeSelection: true,
        enableCellTextSelection: false
    };

    return (
        <AgGridCustomTable
            gridRef={gridRefDateCarGroup}
            gridOptions={gridOptionsDateCarGroup}
            onGridReady={onGridReadyDateCarGroup}
            pagination={false}
        />
    );
};

export default DateCarGroupReport;